import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrderedList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.73389 7H17.7339",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.73389 12H17.7339",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.73389 17H17.7339",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.54605 9V6.58567L5.96973 6.86798V6.34551L6.64262 6H6.96973V9H6.54605Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.51624 13.5V13.1727C5.51624 12.7583 5.70228 12.489 6.1082 12.2403L6.45493 12.029C6.70863 11.8715 6.89045 11.7472 6.89045 11.4075C6.89045 11.1133 6.75514 11.0138 6.46761 11.0138C6.15472 11.0138 6.05324 11.1091 6.03209 11.4779H5.46973C5.49087 10.8605 5.7192 10.5 6.47607 10.5C7.20757 10.5 7.46973 10.8439 7.46973 11.4075C7.46973 11.8923 7.2118 12.1285 6.88622 12.3273L6.54372 12.5428C6.25197 12.721 6.09129 12.8453 6.07861 13.0442H7.42744V13.5H5.51624Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.46973 17.0584H6.01258C6.03299 17.4334 6.13911 17.5516 6.47789 17.5516C6.79218 17.5516 6.91462 17.4457 6.91462 17.1685C6.91462 16.8709 6.80034 16.7486 6.46156 16.7486H6.21258V16.2677H6.4534C6.75136 16.2677 6.87381 16.1535 6.87381 15.8927C6.87381 15.6033 6.73503 15.5054 6.45748 15.5054C6.15544 15.5054 6.04932 15.5992 6.02891 15.962H5.49013C5.51054 15.3546 5.74728 15 6.46564 15C7.17993 15 7.43299 15.3342 7.43299 15.856C7.43299 16.1291 7.30646 16.3451 7.06156 16.4592C7.32687 16.5611 7.46973 16.769 7.46973 17.1481C7.46973 17.6902 7.19626 18 6.46973 18C5.76769 18 5.50238 17.7432 5.46973 17.0584Z",
			fill: "black"
		})
	]
});
export default SvgOrderedList;
